import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
    root:{
        height:'calc(100vh - 59px)',
        backgroundColor:"#F6F6F6"
    }
}))

